var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadGreyBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41634 1.66699C4.26575 1.66699 3.33301 2.59973 3.33301 3.75033V16.2503C3.33301 17.4009 4.26575 18.3337 5.41634 18.3337H13.7497C14.9003 18.3337 15.833 17.4009 15.833 16.2503V7.3068C15.833 6.75426 15.6135 6.22436 15.2228 5.83366L11.6663 2.27719C11.2756 1.88649 10.7457 1.66699 10.1932 1.66699H5.41634ZM10.6247 7.91699C10.6247 7.3417 10.1583 6.87533 9.58301 6.87533C9.00771 6.87533 8.54134 7.3417 8.54134 7.91699V11.6522L7.19458 10.3054C6.78778 9.89863 6.12823 9.89863 5.72144 10.3054C5.31464 10.7122 5.31464 11.3718 5.72144 11.7786L8.84644 14.9036C9.25323 15.3104 9.91278 15.3104 10.3196 14.9036L13.4446 11.7786C13.8514 11.3718 13.8514 10.7122 13.4446 10.3054C13.0378 9.89863 12.3782 9.89863 11.9714 10.3054L10.6247 11.6522V7.91699Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGreyBg);
export default __webpack_public_path__ + "static/media/download-grey-bg.71796b971755dcff2a2b44a27c182b95.svg";
export { ForwardRef as ReactComponent };